import { render, staticRenderFns } from "./encaminhamento.vue?vue&type=template&id=7ef77212&scoped=true"
import script from "./encaminhamento.vue?vue&type=script&lang=js"
export * from "./encaminhamento.vue?vue&type=script&lang=js"
import style0 from "./encaminhamento.vue?vue&type=style&index=0&id=7ef77212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef77212",
  null
  
)

export default component.exports